import React from "react"

import styles from "./Checkbox.module.scss"

/**
 * @param {String} checked - checked value
 * @param {String} [className] - additional className
 * @param {String} labelText - text shown next to checkbox
 * @param {Function} onChange - function to run when changing input
 * @param {Boolean} isSwitch - whether the checkbox should be displayed as a switch
 */
const Checkbox = (props) => {
    const { checked, className, labelText, onChange, isSwitch, name, value, id } = props;
    const disabled = props.disabled ? 'disabled' : '';
    return isSwitch ? (
        <label
            className={`${styles["switch-wrap"]} ${
                !checked ? styles["switch-wrap-inactive"] : ""
            }`}
        >
            <input checked={checked} onChange={onChange} type="checkbox" />
            <div className={styles.switch} />
        </label>
    ) : (
        <label className={`${styles["checkbox-container"]} ${className || ""}`}>
            <input
                id={id || null}
                disabled={disabled}
                checked={checked}
                className={styles["input-checkbox"]}
                type="checkbox"
                onChange={onChange}
                name={name || ""}
                key={value || ""}
                value={value || ""}
            />
            <i />
            {labelText && <span>{labelText}</span>}            
        </label>
    )
}

export default Checkbox
